import { Url } from 'next/dist/shared/lib/router/router';
import NextLink from 'next/link';

import { cn } from '@/shared/lib/cn';

interface BreadcrumbsItemProps {
  children: React.ReactNode;
  isCurrentPage?: boolean;
  href?: Url;
}

export const BreadcrumbsItem = (props: BreadcrumbsItemProps) => {
  const { children, isCurrentPage = false, href } = props;

  const LinkComponent = href ? NextLink : 'span';

  return (
    <li className="inline-flex items-center" aria-current={isCurrentPage ? 'page' : undefined}>
      <LinkComponent
        href={href as Url}
        className={cn('inline-flex items-center text-sm font-medium', isCurrentPage && 'text-muted-foreground')}
      >
        {children}
      </LinkComponent>

      {!isCurrentPage && (
        <span role="presentation" className="mx-2">
          /
        </span>
      )}
    </li>
  );
};
